import React from "react";
import CareProviderDashboard from "../../referralCareDirectory/careReferral/pages/careProviderDashboard";

export default function CareDashboardProductPage(): JSX.Element {
  return <CareProviderDashboard />;
}
